import { render, staticRenderFns } from "./SalesOrderDocumentsPanel.vue?vue&type=template&id=4bb32c0e&scoped=true"
import script from "./SalesOrderDocumentsPanel.vue?vue&type=script&lang=js"
export * from "./SalesOrderDocumentsPanel.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderDocumentsPanel.vue?vue&type=style&index=0&id=4bb32c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb32c0e",
  null
  
)

export default component.exports